import { useTranslation } from "react-i18next";
import { useEffect, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";


import { useState } from "react";
import Box from '@mui/material/Box';
import Layout from "../shared/components/LayoutComponent";
import List from '@mui/material/List';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Page from "../shared/components/PageComponent";
import { useMessage } from "../../context/message-context";
import { Badge, Button, Chip, Divider, IconButton, ListItem, ListItemIcon, ListItemText, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip } from "@mui/material";
import { FullPageSpinner } from "../lib";
import { fetchNewsUpdates } from "./fetchNewsUpdates";
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import { useZulassung } from "../../context/zulassungs-context";


function NewsEintrag({ client, accessToken, updateTitle }) {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false)
    const { showErrorMessage } = useMessage();
    const [newsData, setNewsData] = useState()
    const [searchParams, setSearchParams] = useSearchParams();
    const { zulassung, updateNewsAmount } = useZulassung();

    const entryIdForNews = useMemo(() => {
        if (searchParams && searchParams.get("entryId")) {
            return searchParams.get("entryId");
        } else {
            return null;
        }
    }, [searchParams]);

    useEffect(() => {
        if (entryIdForNews) {
            setIsLoading(true);
            fetchNewsUpdates("HOLE_NEWS_EINTRAG", accessToken, "", entryIdForNews)
                .then((data) => {
                    if (data) {
                        setNewsData(data)
                        if (data.betreffbez) updateTitle(data.betreffbez)
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    setIsLoading(false);
                })
        } else setNewsData()

    }, [entryIdForNews])

    const handleInteraction = (interaction) => {
        let subProgramm
        switch (interaction) {
            case "gelesen":
                subProgramm = "NEWS_EINTRAG_GELESEN"
                break;
            case "like":
                subProgramm = "NEWS_EINTRAG_LIKE"
                break;
            case "dislike":
                subProgramm = "NEWS_EINTRAG_DISLIKE"
                break;
            default:
                break;
        }
        if (!subProgramm) return console.log("Es ist ein Fehler unterlaufen.");
        setIsLoading(true);
        fetchNewsUpdates(subProgramm, accessToken, "", entryIdForNews, interaction)
            .then((data) => {
                if (data) {
                    setNewsData(data)
                    if (data.betreffbez) updateTitle(data.betreffbez)
                    if (interaction === "gelesen" && zulassung.newsAmount > 0) updateNewsAmount(zulassung.newsAmount - 1)
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                setIsLoading(false);
            })
    }

    const buttonDisable = () => {
        if (isLoading || (newsData.originalautor && newsData.originalautor === "1")) return true
        return false
    }

    const buttonText = () => {
        if (newsData.originalautor && newsData.originalautor === "1") return t("Sie sind original Autor")
        return t("Gefällt mir!")
    }

    return (
        <>
            {isLoading && <FullPageSpinner />}
            <Page>
                <Layout >
                    <Box sx={{ flexGrow: 1 }} >
                        <Grid container direction={"column"} >
                            {newsData && <>
                                <Grid item width={"100%"} sx={{ display: "flex", flexDirection: "column", justifyContent: "center" }} >
                                    <Stack direction={{ xs: "column", sm: "row" }} sx={{ justifyContent: "space-between" }} padding={2} spacing={1}>
                                        <Stack>
                                            <Chip
                                                label={newsData.betrefftitel}
                                            />
                                        </Stack>
                                        <Stack>
                                            {newsData.anzahllikes && Number(newsData.anzahllikes.trim()) > 0 && < Chip
                                                icon={<ThumbUpIcon fontSize="small" />}
                                                label={t("Eintrag gefällt ") + newsData.anzahllikes.trim() + (Number(newsData.anzahllikes.trim()) > 1 ? t(" Personen") : t(" Person"))}
                                            />}
                                        </Stack>
                                    </Stack>
                                    <Box margin={"auto"} maxWidth={"100%"} dangerouslySetInnerHTML={{ __html: newsData.htmlinhalt }} />
                                </Grid>
                                <Grid item padding={2} sx={{ alignSelf: { xs: "center", sm: "flex-end" } }}  >
                                    <Stack direction={"row"} spacing={2} sx={{ justifyContent: { xs: "center", sm: "flex-end" } }}>
                                        {newsData.gelesenstatus && newsData.gelesenstatus !== "2" &&
                                            <Button disabled={isLoading} sx={{ width: { xs: "50%", sm: "auto" } }} onClick={() => { handleInteraction("gelesen") }} variant="contained" color="primary">{t("Als Gelesen markieren")}</Button>}
                                        {newsData.likestatus && newsData.likestatus === "1" ?
                                            <Button disabled={buttonDisable()} sx={{ width: { xs: "50%", sm: "auto" } }} onClick={() => { handleInteraction("dislike") }} variant="contained" color="primary">{t("Gefällt mir doch nicht")}</Button>
                                            :
                                            <Button disabled={buttonDisable()} sx={{ width: { xs: newsData.gelesenstatus === "2" ? "100%" : "50%", sm: "auto" } }} onClick={() => { handleInteraction("like") }} variant="contained" color="primary">{buttonText()}</Button>}
                                    </Stack>
                                </Grid>
                            </>}
                        </Grid>
                    </Box>
                </Layout>
            </Page >
        </>
    )
}

export default NewsEintrag; 